import memoize from 'lodash/memoize'
import pick from 'lodash/pick'
import Event from 'base/event'
import Hub from 'base/hub'
import Cookies from 'js-cookie'
import cookies from 'cookies.yml'

function navTiming() {
  // IE & Safari don't have PerformanceNavigationTiming
  const timing = window.performance?.getEntriesByType?.('navigation')?.[0]

  return pick(timing || {}, [
    'connectEnd',
    'connectStart',
    'domComplete',
    'domInteractive',
    'domainLookupEnd',
    'domainLookupStart',
    'duration',
    'encodedBodySize',
    'fetchStart',
    'loadEventEnd',
    'loadEventStart',
    'requestStart',
    'responseEnd',
    'responseStart',
    'startTime',
    'transferSize',
  ])
}

export default memoize(function triggerLandEvent() {
  const landData = {
    path: window.location.pathname,
    previous_url: document.referrer,
    onland_fullpath: Cookies.get(cookies.ONLAND_FULLPATH),
  }

  Object.assign(landData, navTiming())

  if (window.performance?.mark) {
    window.performance.mark('land')
    landData.land = window.performance.getEntriesByName('land')[0]?.startTime
  }

  Hub.pub(Event.App.LAND, landData)
})
